import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "api/axiosInstance";
import { notify } from "../utils/notificationUtils";
import dayjs from "dayjs";

export const listAppointments = createAsyncThunk(
    "appointments/list",
    async (filters = '', thunkAPI) => {
        try {
            const queryString = Object.keys(filters).map((key) => `${key}=${filters[key]}`).join("&");

            const { data } = await api.get(`/appointments?${queryString}`);

            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createAppointment = createAsyncThunk(
    "appointments/create",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.post("/appointments", data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateAppointment = createAsyncThunk(
    "appointments/update",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.put(`/appointments/${data.id}`, data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const cancelAppointment = createAsyncThunk(
    "appointments/cancel",
    async (id, thunkAPI) => {
        try {
            await api.put(`/appointments/${id}/cancel`);
            return thunkAPI.fulfillWithValue(id);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const appointmentsSlice = createSlice({
    name: "appointments",
    initialState: {
        appointments: [],
        selectedAppointment: null
    },
    reducers: {
        setSelectedAppointment: (state, action) => {
            state.selectedAppointment = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(listAppointments.fulfilled, (state, action) => {
                state.appointments = action.payload.map(appointment => {
                    appointment.id = appointment.id
                    appointment.title = appointment.customer.name
                    appointment.start = appointment.start_date
                    appointment.end = appointment.end_date
                    appointment.color = appointment.order ? '#10b981' : '#3b82f6'

                    return appointment
                });
            })
            .addCase(createAppointment.fulfilled, (state, action) => {
                notify('Cita creada exitosamente', 'success')
                action.payload.title = action.payload.customer.name
                action.payload.start = action.payload.start_date
                action.payload.end = action.payload.end_date
                state.appointments = [...state.appointments, action.payload];
            })
            .addCase(updateAppointment.fulfilled, (state, action) => {
                notify('Cita actualizada exitosamente', 'success')
                action.payload.title = action.payload.customer.name
                action.payload.start = action.payload.start_date
                action.payload.end = action.payload.end_date
                state.appointments = state.appointments.map(appointment =>
                    appointment.id === action.payload.id ? action.payload : appointment
                );
            })
            .addCase(cancelAppointment.fulfilled, (state, action) => {
                notify('Cita cancelada exitosamente', 'success')
                state.appointments = state.appointments.filter(appointment =>
                    appointment.id !== action.payload
                );
            })
    }
});

export const {
    setSelectedAppointment
} = appointmentsSlice.actions;

export default appointmentsSlice.reducer;
